import React, { useEffect , useState} from 'react';
import '../../../stylesheets/triagebot/SummarySkeleton.scss';
import { useDetectMobile } from '../utils';

const SummarySkeleton = ({ message }) => {

    const {isMobile} = useDetectMobile();
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
    const preInfoText = message?.data?.[0]?.preInfoText?.length
        ? message.data[0].preInfoText
        : ['', '', '', '', ''];

    const messages = [
        preInfoText[0],
        preInfoText[1],
        preInfoText[2],
        preInfoText[3],
        preInfoText[4]
        ];

        useEffect(() => {
            const interval = setInterval(() => {
                setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
            }, 3000); // Rotate every 3 seconds
    
            return () => clearInterval(interval);
        }, [messages.length]);


    return(
        <div className={'summary-skeleton card'}>
            <div className='skeleton-tabBar'>
                <div className={(isMobile ? 'mobile ': '') + 'loadAnim strip1'}>
                    <div className='anim'>&nbsp;</div>
                </div>
                <div className={(isMobile ? 'mobile ': '') + 'loadAnim strip2'}>
                    <div className='anim'>&nbsp;</div>
                </div>
            </div>
            <div className='loadAnim strip3'>
                <div className='anim'>&nbsp;</div>
            </div>
            <div className='loadAnim strip4'>
                <div className='anim'>&nbsp;</div>
            </div>
            <div className={(isMobile ? 'mobile ': '') + 'loadAnim strip5'}>
                <div className='anim'>&nbsp;</div>
            </div>
            <div className='loadAnim strip6'>
                <div className='anim'>&nbsp;</div>
            </div>
            <div className='loadAnim strip7'>
                <div className='anim'>&nbsp;</div>
            </div>
            <div className='loadAnim strip8'>
                <div className='anim'>&nbsp;</div>
            </div>
            <div className={(isMobile ? 'mobile ': '') + 'loadAnim strip9'}>
                <div className='anim'>&nbsp;</div>
            </div>
            <div className='loadAnim strip10'>
                <div className='anim'>&nbsp;</div>
            </div>
            <div className='loadAnim strip11'>
                <div className='anim'>&nbsp;</div>
            </div>
            <div className='loadAnim strip12'>
                <div className='anim'>&nbsp;</div>
            </div>
            <div className='loadAnim strip13'>
                <div className='anim'>&nbsp;</div>
            </div>
            <div className='loadAnim strip14'>
                <div className='anim'>&nbsp;</div>
            </div>
            <div className="loader-container">
                <svg className="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle className="path" fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30"></circle>
                </svg>
                <div className="rotating-messages">
                    {messages.map((message, index) => (
                        <p 
                            key={index} 
                            className={`message ${index === currentMessageIndex ? 'active' : ''}`}
                        >
                            {message}
                        </p>
                    ))}
                </div>
            </div>
        </div>
    )
}
export default SummarySkeleton;